module.exports = __webpack_public_path__ + "static/img/fish18.9456cd4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/flydragonfish/fish18.png
// module id = syHL
// module chunks = 0